function LocationExt(url) {
    this.href = url || location.href.toString();
    this.hash = this.href.replace(/^[^#]+(.*)$/, '$1');

    let qstr = this.href.replace(/#.*/gi, '').replace(/^[^?]+(.*)$/, '$1')
        .replace(/^\?/gi, '');
    let base = this.href.replace(this.hash, '').replace(/^([^?]+)(.*)$/, '$1');
    let qobj = {};
    let qarr = [];
    const me = this;

    Object.defineProperty(this, 'base', {
        get() {
            return base;
        },
        set(val) {
            base = val;
            updateHref();
        },
    });

    qstr = qstr === this.href ? '' : qstr;

    if (qstr !== '') {
        qarr = qstr.split('&');
        for (let i = 0, l = qarr.length; i < l; i++) {
            const parr = qarr[i].split('=');
            if (parr[0]) {
                qobj[parr[0]] = parr[1] ? parr[1] : '';
            }
        }
    }

    this.search = qobj;

    this.get = function (key) {
        return qobj[key];
    };

    this.set = function (key, value) {
        if (typeof key === 'object') {
            for (const k in key) {
                qobj[k] = key[k];
            }
        } else {
            qobj[key] = value;
        }
        updateHref();
        return me;
    };

    this.remove = function (key) {
        delete qobj[key];
        updateHref();
        return me;
    };

    this.clear = function () {
        qobj = {};
        me.search = qobj;
        updateHref();
        return me;
    };

    this.output = function () {
        const arr = [];
        for (const key in qobj) {
            arr.push(`${key}=${(qobj[key] === undefined) ? '' : qobj[key]}`);
        }
        return arr.join('&');
    };

    function updateHref() {
        const qs = me.output();
        me.href = base + (qs ? (`?${qs}`) : '') + ((me.hash === '#') ? '' : me.hash);
    }
}

export default LocationExt;
